module.exports = __webpack_public_path__ + "static/savognin-1979aee1492fa371824d9e0651659d17.png";